import { useSiteSettings } from "@/hooks/useSiteSettings";
import { DEFAULT_SITE_SETTINGS } from "@/lib/siteSettings";
import { PebbleGround } from "./PebbleGround";

export function FeatureStrip() {
  const { data: settings } = useSiteSettings();
  const bg = settings?.promo_marquee_bg_color ?? DEFAULT_SITE_SETTINGS.promo_marquee_bg_color;
  const text = settings?.promo_marquee_text_color ?? DEFAULT_SITE_SETTINGS.promo_marquee_text_color;
  const phrase = settings?.promo_marquee_text ?? DEFAULT_SITE_SETTINGS.promo_marquee_text;

  const renderItems = () =>
    Array.from({ length: 8 }).map((_, i) => (
      <span key={i} className="flex shrink-0 items-center gap-8">
        <span className="font-heading text-lg md:text-xl uppercase tracking-[0.15em]">
          {phrase}
        </span>
        <span className="text-sm">◆</span>
      </span>
    ));

  return (
    <section className="overflow-hidden py-5" style={{ backgroundColor: bg, color: text }}>
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        <div className="flex shrink-0 items-center gap-8 px-4">
          {renderItems()}
        </div>
        <div className="flex shrink-0 items-center gap-8 px-4">
          {renderItems()}
        </div>
        <div className="flex shrink-0 items-center gap-8 px-4">
          {renderItems()}
        </div>
      </div>
      <PebbleGround />
    </section>
  );
}
